import { PageHero } from '../components/ui/PageHero.jsx';
import { Section, Wrap } from '../components/ui/Section.jsx';
import { Button } from '../components/ui/Button.jsx';

export const meta = {
  title: 'Page not found — Abode Custom Homes',
  description: 'That page does not exist.',
  noindex: true,
};

export default function NotFoundPage() {
  return (
    <>
      <PageHero
        eyebrow="404"
        lines={["That page isn't", 'here anymore.']}
        lede="The link may be out of date, or the page may have moved. Everything we have is a click away below."
      />
      <Section>
        <Wrap>
          <Button to="/">Back to the home page</Button>
        </Wrap>
      </Section>
    </>
  );
}
